import styled from 'styled-components';
import { Code } from '@decisiv/ui-components';

export const DeveloperCodeView = styled(Code)`
  background: var(--if-code-bg);
  color: var(--if-code-fg);
  margin: 0;
  padding: 20px;
  letter-spacing: -0.8px;
  overflow: auto;
  width: 100%;

  &::selection,
  & *::selection {
    background: var(--if-focus);
    color: var(--if-code-fg);
  }
`;
